import { render, staticRenderFns } from "./SendButtonIcon.vue?vue&type=template&id=8e7e4306&"
import script from "./SendButtonIcon.vue?vue&type=script&lang=js&"
export * from "./SendButtonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports